var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-app',{ref:"nav"}),_c('div',{staticStyle:{"min-height":"calc(100vh - 81px - 108px)"}},[_vm._t("default")],2),_c('footer-app',{ref:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }